import { ApolloError } from '@apollo/client';
import { useGetApprovalConfigurationQuery } from '../../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import {
  APP_GOVERNANCE_APPROVAL_ACTION,
  APP_GOVERNANCE_APPROVAL_TYPE_ID,
} from '../constants';

interface UseGetProductApprovalConfigurationProps {
  skip?: boolean;
}

interface ProductApprovalConfiguration {
  enabled: boolean;
  loading: boolean;
  error?: ApolloError;
  refetch: Function;
}

//Checks if portal is enabled for Product Approvals
export function useGetProductApprovalConfiguration({
  skip = false,
}: UseGetProductApprovalConfigurationProps): ProductApprovalConfiguration {
  const { data, loading, error, refetch } = useGetApprovalConfigurationQuery({
    variables: {
      approvalTypeId: APP_GOVERNANCE_APPROVAL_TYPE_ID,
      approvalAction: APP_GOVERNANCE_APPROVAL_ACTION,
    },
    skip,
  });

  const configurationEnabled = data?.approvalConfiguration.enabled;

  return {
    enabled: configurationEnabled === undefined ? false : configurationEnabled,
    loading,
    error,
    refetch,
  };
}
